import React from "react";
import { path } from "ramda";
import { Stack } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { HyroButton } from "@hyro-components";
import { BUTTON_COLORS, BUTTON_SIZES, BUTTON_VARIANTS } from "@hyro-components/hyro-button/HyroButton.consts";
import CloseIcon from "src/icons/CloseIcon";
import palette from "src/theme/palette";
import { ALL_FILTER, CHANGE_BADGES, REVIEW_COPY, REVIEW_FILTERS } from "./reviewChanges.consts";

const filterButtonProps = { variant: BUTTON_VARIANTS.OUTLINED, color: BUTTON_COLORS.SECONDARY, size: BUTTON_SIZES.SMALL };

// "All 8  • Edited 3  • Added 4  • Removed 1  Clear all": any number of change types can be selected.
const ReviewFilters = ({ counts, selected, onToggle, onClear }) => (
  <Stack direction="row" gap={1} alignItems="center" flexWrap="wrap">
    <HyroButton {...filterButtonProps} active={!selected.length} aria-pressed={!selected.length} data-testid="review-filter-all" onClick={onClear}>
      {`${ALL_FILTER.label} ${counts.all}`}
    </HyroButton>
    {REVIEW_FILTERS.map(({ value, label, countKey }) => {
      const isSelected = selected.includes(value);
      return (
        <HyroButton
          {...filterButtonProps}
          key={countKey}
          active={isSelected}
          aria-pressed={isSelected}
          disabled={!counts[countKey]}
          data-testid={`review-filter-${countKey}`}
          startIcon={<FiberManualRecordIcon sx={{ color: path(CHANGE_BADGES[value].dot, palette) }} />}
          endIcon={isSelected ? <CloseIcon width={12} height={12} color={palette.primary[500]} /> : null}
          onClick={() => onToggle(value)}
        >
          {`${label} ${counts[countKey]}`}
        </HyroButton>
      );
    })}
    {selected.length > 0 && (
      <HyroButton variant={BUTTON_VARIANTS.TEXT} size={BUTTON_SIZES.SMALL} data-testid="review-filter-clear" onClick={onClear}>
        {REVIEW_COPY.CLEAR_ALL}
      </HyroButton>
    )}
  </Stack>
);

export default ReviewFilters;
